import React, { Component } from 'react';
import '../../css/VPTOverview.css';
import '../../css/bootstrap.min.css';
import {  Link } from "../../components";
import {getUrlParameter} from '../../lib/api';
class ThankYou extends Component {

    render() {
        let user = getUrlParameter('user');
        if(!user){
            return <h3 style={{textAlign:'center'}}>Not valid token passed</h3>
        }
        return (
            <div style={{backgroundImage:"url(/images/bg.png)", backgroundRepeat: 'no-repeat',padding:'10px'}}>
                <div className="container">
                    <div className="whtbg thnkbg">
                        <div className="col-lg-12 detls thankyoulogo">
                            <div className="col-sm-6 col-xs-12 pdleft">
                                <a href="https://edwisely.com">
                                    <img src="/images/Edwisely_logo.svg"/>
                                </a>
                               
                            </div>
                        </div>

                        <div className="summary">
                            <div className="col-lg-12">
                                <p className="thankhed">Thank you for taking Edwisely Comprehensive Assessment!</p>
                                <p className="thancnt ">Please click below for your test results</p>
                            </div>
                        </div>
                        <Link to={`/vpt/overview/?user=${user}`}>
                            <button type="button" className="btn btn-primary thnkbtn">Test Results</button>
                        </Link>
                        
                        <br/>
                        <br/>
                        <div>
                            <span><a href="https://www.edwisely.com/privacy.html" target="_blank">Privacy policy </a> &nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://www.edwisely.com/tos.html" target="_blank">Terms &amp; Conditions</a></span><br/>
                        </div>
                        <p style={{marginTop:'10px'}} className="cpyrghts">All Rights Reserved. © 2019  Edwisely. Copyright of Hakate Technologies Pvt. LTD</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThankYou;